<template>
  <div class="bankcard-modal">
    <vix-suspend-menu :show="show" class="bank-suspend" @clickMask="closeGuideModal">
      <div class="nav-bar">
        <img src="../assets/select-close.png" alt="" class="modal-close" @click="closeGuideModal" />
      </div>
      <div class="title">{{ title }}</div>
      <div v-if="subTitle" class="sub-title">{{ subTitle }}</div>
      <div class="bank-box">
        <div v-for="(bankcard, index) in newBankList" :key="index" v-tap class="bank" @click="changeBank(index)">
          <img class="bank-icon" :src="bankcard.status === 0 ? bankcard.icon.enable : bankcard.icon.disable" alt="💳" />
          <vix-cell access class="bank-cell">
            <vix-cell-left :class="bankcard.status ? 'disable' : ''">
              <div class="content">
                <div class="text">{{ bankcard.name }} {{ bankcard.card_info ? bankcard.card_info.name_ext : '' }}</div>
                <div class="tip" :class="{ 'tip-warning': bankcard.maintain_info }">
                  {{ bankcard.maintain_info || bankcard.status_info || tipText }}
                </div>
              </div>
            </vix-cell-left>
            <img v-if="selectedCardIndex === index" class="icon-success" src="../assets/icon-success.png" alt="" />
            <img v-if="bankcard.name === '添加储蓄卡'" :src="addUrl" class="add-bank" alt="+" />
          </vix-cell>
        </div>
      </div>
      <div v-tap class="add-bankcard bank" @click="changeBank(bankCardList.length - 1)">
        <img class="bank-icon" :src="addBank && addBank.icon ? addBank.icon.enable : ''" alt="+" />
        <vix-cell class="bank-cell">
          <vix-cell-left>
            <div class="content">
              <div class="text">{{ addBank ? addBank.name : '' }}</div>
            </div>
          </vix-cell-left>
          <i v-if="selectedCardIndex === bankCardList.length - 1" class="icon-success"></i>
          <img src="../assets/select-modal-arrow.png" class="add-bank" alt=">" />
        </vix-cell>
      </div>
    </vix-suspend-menu>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { SuspendMenu as VixSuspendMenu } from '@mx/vix';
import { assetsConfig } from '../common';

export default Vue.extend({
  name: 'BankcardModal',
  components: {
    VixSuspendMenu,
  },
  props: {
    bankCardList: {
      default: () => [],
      type: Array,
    },
    selectedCardIndex: {
      default: -1,
      type: Number,
    },
    tipText: {
      default: '',
      type: String,
    },
    subTitle: {
      default: '',
      type: String,
    },
    title: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      selectedCard: {} as BankCardType,
      focus: true,
      newBankList: [] as BankCardType[],
      addBank: {} as BankCardType,
      addUrl: assetsConfig.addUrl,
      show: true,
    };
  },
  watch: {
    bankCardList(newVal, oldVal) {
      this.newBankList = newVal.filter((item: any, index: number) => {
        if (index !== newVal.length - 1) {
          return item;
        }
      });
      this.addBank = newVal[newVal.length - 1];
    },
  },
  methods: {
    changeBank(index: number) {
      this.$emit('changeBank', index);
    },
    closeGuideModal() {
      // b
      this.$emit('onHide');
    },
    onHide() {
      this.$emit('onHide');
    },
  },
});
</script>
<style lang="less" scoped>
@import '../styles/vars.less';

.bankcard-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
}
.bank-suspend {
  /deep/ .suspend-menu-box {
    padding: 0;
    background: #ffffff;
    border-radius: 0.48rem 0.48rem 0 0;
    padding-bottom: 0.68rem;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  /deep/ .suspend-menu-mask {
    background: rgba(0, 0, 0, 0.7);
  }
  .nav-bar {
    .modal-close {
      width: 0.32rem;
      height: 0.32rem;
      top: 0.43rem;
      right: 0.36rem;
    }
  }
  .title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 0.36rem;
    color: #191919;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.36rem;
    font-weight: 500;
    margin-top: 0.36rem;
  }
  .sub-title {
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 0.28rem;
    color: #999999;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.28rem;
    font-weight: 400;
    margin-top: 0.16rem;
  }
}
.bank-box {
  margin-top: 0.47rem;
  max-height: 8rem;
  overflow: scroll;
}
.bank {
  display: flex;
  align-items: center;
  padding: 0 0.32rem;
  .bank-icon {
    width: 0.32rem;
    height: 0.32rem;
    margin-top: -0.38rem;
  }
  .bank-cell {
    flex-grow: 1;
    text-align: left;
    padding: 0;
    margin-left: 0.16rem;
    min-height: 0;
    padding: 0.24rem 0;
    .content {
      .text {
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.28rem;
        color: #191919;
        line-height: 0.28rem;
        font-weight: 400;
      }
      .tip {
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.24rem;
        color: #999999;
        line-height: 0.24rem;
        font-weight: 400;
        margin-top: 0.12rem;
        &-warning {
          color: #f52916;
        }
      }
    }
    .icon-success {
      width: 0.4rem;
      height: 0.4rem;
      background: #ffdd00;
      border-radius: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      font-size: 0.2rem;
    }
  }
  .bank-cell::after {
    display: inline-block;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.04);
  }
  .bank-cell .disable .content .text {
    color: @theme-tip-color !important;
  }
}
.add-bankcard {
  padding-bottom: 0.18rem;
  .bank-icon {
    width: 0.32rem;
    height: 0.32rem;
    margin-top: 0;
  }
  .bank-cell {
    padding: 0.42rem 0;
  }
  .add-bank {
    width: 0.2rem;
    height: 0.2rem;
  }
  .bank-cell::after {
    display: none;
  }
}
</style>
